import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

export const LoadMoreWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
export const LoadMoreCTA = styled.button`
  padding: 0;
  background: inherit;
  border: none;
  font-family: 'Audi Type';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  border-bottom: 1px solid ${COLORS.black};
  padding-bottom: 2px;
  cursor: pointer;
`;
